import type { DateOrRange, FlexibleRange } from '@/infrastructure/departure-date/store'
import { differenceInDays } from 'date-fns'

export function getFlexibleRangeForDepartureDate(departureDate: DateOrRange): FlexibleRange {
  if (departureDate === undefined || !Array.isArray(departureDate))
    return 'exact'

  const diff = differenceInDays(new Date(departureDate[1]), new Date(departureDate[0]))

  switch (diff) {
    case 2:
      return '1 day'
    case 6:
      return '3 days'
    case 14:
      return '7 days'
    default:
      return 'exact'
  }
}
